export function useInterpolatedContent(content, cmsMessageProps) {
  return content.replace(/\${(.*?)}/g, (tag, prop) => cmsMessageProps[prop]);
}
